import { ICryptoProvider } from "../CryptoInterfaces";
import { IKeyDef, IMessageBody } from "./MessagesInterface";
// Oddělen z MessageInterface kvůli sve závisloti CryptoInterface, ktera pak do Extension přidavala zbytečné importy
export interface IDecryptKeys extends IMessageBody {
    provider: ICryptoProvider;
    keys: IKeyDef[];
    /** Base64 reprezentace certifikátu, kterým byla data zašifrována. */
    certificate: string;
}
